import { AttributeHtmlBridgePrototype } from "../bridges/bridgeTypes/attribute";
import { AttributePresenceHtmlBridgePrototype } from "../bridges/bridgeTypes/attributePresence";
import { ComponentBridgePrototype } from "../bridges/bridgeTypes/compoent";
import { ComponentAttachedPropertyHtmlBridgePrototype } from "../bridges/bridgeTypes/componentAttachedProperty";
import { ComponentPropertyHtmlBridgePrototype } from "../bridges/bridgeTypes/componentProperty";
import { ContentBridgePrototype } from "../bridges/bridgeTypes/content";
import { EventHtmlBridgePrototype } from "../bridges/bridgeTypes/event";
import { ClassHtmlBridgePrototype } from "../bridges/bridgeTypes/htmlClass";
import { InnerTextBridgePrototype } from "../bridges/bridgeTypes/innerText";
import { ItemsSourceHtmlBridgePrototype } from "../bridges/bridgeTypes/itemsSource";
import { StyleHtmlBridgePrototype } from "../bridges/bridgeTypes/style";
import { BindingPrototype } from "./bindingPrototype";
import { HtmlBridgePrototype } from "./htmlBridgePrototype";

export class HtmlBridgePrototypeFactory{
    public getPrototype(node:Node,attribute:string,expression:BindingPrototype): HtmlBridgePrototype{
        let result:HtmlBridgePrototype;
        if(attribute.startsWith('attr-')){
            let a =new AttributeHtmlBridgePrototype();
            a.attributeName = attribute.substring(5);             
            result=a;
        }else if(attribute.startsWith('attribute-')){
            let a =new AttributePresenceHtmlBridgePrototype();
            a.attributeName = attribute.substring(10);             
            result=a;
        }else if(attribute.startsWith('component')){
            let a =new ComponentBridgePrototype();
            result=a;
        }else if(attribute.startsWith('attach-')){
            let a =new ComponentAttachedPropertyHtmlBridgePrototype();
            a.propertyName = attribute.substring(7);             
            result=a;
        }else if(attribute.startsWith('comp-')){
            let a =new ComponentPropertyHtmlBridgePrototype();
            a.propertyName = attribute.substring(5);             
            result=a;
        }else if(attribute.startsWith('content')){
            let a = new ContentBridgePrototype();
            result = a;
        }else if(attribute.startsWith('event-')){
            let a =new EventHtmlBridgePrototype();
            a.eventName = attribute.substring(6);             
            result=a;
        }else if(attribute.startsWith('class-')){
            let a =new ClassHtmlBridgePrototype();
            a.className = attribute.substring(6);             
            result=a;
        }else if(attribute.startsWith('itemssource')){
            let a =new ItemsSourceHtmlBridgePrototype();
            result=a;
        }else if(attribute.startsWith('style-')){
            let a =new StyleHtmlBridgePrototype();
            a.styleName = attribute.substring(6);             
            result=a;
        }else if(attribute=="TextNodeTextContent"){
            let a = new InnerTextBridgePrototype();
            result=a;
        }
        result.binding = expression;
        result.node = node;
        return result;
    } 
}
